import React, { useMemo } from "react";
import { Autocomplete, TextField, Box } from "@mui/material";
import Styles from "./AutoComplete.module.scss";

const CommonAutoComplete = ({
  options,
  placeholder = "Select option",
  onChange,
  value,
  disabled,
  getOptionLabel,
  multiple = false,
}) => {
  const selectedValue = useMemo(() => {
    if (multiple) {
      if (!Array.isArray(value)) return [];
      return options.filter((opt) =>
        value.some((val) => (val?._id || val?.id || val) === (opt?._id || opt?.id))
      );
    }
    return options.find((el) => (el?._id || el?.id) === (value?._id || value)) || null;
  }, [options, value, multiple]);

  return (
    <Box className={Styles.autocomplete}>
      <Autocomplete
        multiple={multiple}
        disabled={disabled}
        options={options}
        onChange={onChange}
        isOptionEqualToValue={(e, v) => (e?._id || e?.id) === (v?._id || v?.id)}
        getOptionLabel={getOptionLabel || ((option) => option.label || "")}
        value={selectedValue}
        renderInput={(params) => (
          <TextField
            className={Styles.textField}
            {...params}
            focused={false}
            placeholder={placeholder}
          />
        )}
        clearOnBlur={false}
      />
    </Box>
  );
};

export default CommonAutoComplete;
